import { Config, ConfigProvider, Effect } from "effect";

const ClientConfig = Config.all({
  VITE_CONVEX_URL: Config.string("VITE_CONVEX_URL"),
  VITE_APP_ENV: Config.literal(
    "development",
    "preview",
    "production",
  )("VITE_APP_ENV").pipe(Config.withDefault("development" as const)),
  VITE_E2E: Config.boolean("VITE_E2E").pipe(Config.withDefault(false)),
  VITE_SENTRY_DSN: Config.string("VITE_SENTRY_DSN").pipe(Config.withDefault("")),
  DEV: Config.boolean("DEV").pipe(Config.withDefault(false)),
  PROD: Config.boolean("PROD").pipe(Config.withDefault(false)),
});

export type ClientEnv = {
  readonly VITE_CONVEX_URL: string;
  readonly VITE_APP_ENV: "development" | "preview" | "production";
  readonly VITE_E2E: boolean;
  readonly VITE_SENTRY_DSN: string;
  readonly DEV: boolean;
  readonly PROD: boolean;
};

const provider: ConfigProvider.ConfigProvider = ConfigProvider.fromMap(
  new Map(
    Object.entries(import.meta.env).flatMap(([key, value]): Array<[string, string]> => {
      if (typeof value === "string") return [[key, value]];

      if (typeof value === "boolean" || typeof value === "number") {
        return [[key, String(value)]];
      }

      return [];
    }),
  ),
);

export const env: ClientEnv = Effect.runSync(
  ClientConfig.pipe(Effect.withConfigProvider(provider)),
);
